import Lottie from 'lottie-react';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useMsal } from '@azure/msal-react';
import { IconButton } from '@mui/material';

import SuccessLottie from '../../../../assets/lottie/97240 success.json';
import { msalConfig, urlConfig } from '../../../../config';
import { images } from '../../../../constant';
import { usePayLinkCart } from '../../context/PayLinkCartContext';
import { usePayLinkUser } from '../../context/PaylinkUserContext';
import { EarnableRewards } from '../checkout/components';

const PAYLINK_LOCAL_STORAGE_KEYS = [
  "paylink_cart_items",
  "paylink_c_s",
  "C_S",
  "P_D",
  "session_data",
  "loginFlow",
  "mode",
  "redirectUrl",
];

export const OrderConfirmed = () => {
  const { user } = usePayLinkUser();
  const { storeProfile } = usePayLinkCart();
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const storeSlug = storeProfile?.slug;
    const storePath = storeSlug ? `/paylink/s/${storeSlug}` : "/paylink";

    const timer = setTimeout(() => {
      // Clear paylink session data
      PAYLINK_LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
      if (storeProfile?.customerUniqueReferenceNumber) {
        localStorage.removeItem(storeProfile.customerUniqueReferenceNumber);
      }

      const account = accounts?.[0];
      if (account) {
        // Authenticated: MSAL logout, land back on the store page via /logout
        instance.logoutRedirect({
          account,
          postLogoutRedirectUri: window.location.origin + "/logout",
        });
      } else {
        // Guest: just navigate to the store page
        navigate(storePath, { replace: true });
      }
    }, 8000);

    return () => clearTimeout(timer);
  }, [storeProfile, accounts, instance, navigate]);

  return (
    <section className="!container">
      <div className="flex flex-col !gap-6 w-full !p-5 lg:!pt-6 lg:!pb-10">
        <div className="flex flex-col text-center !gap-4 max-w-[340px] mx-auto">
          <Lottie
            className="mx-auto d-block w-[150px] h-[150px]"
            animationData={SuccessLottie}
            loop={true}
          />
          <h4 className="text-xl text-py_black-950 font-semibold leading-[120%] tracking-[-0.02em]">
            Order confirmed
          </h4>
          <p className="text-base text-py_black-500 leading-[140%] tracking-[-0.02em]">
            Receipt sent to {user?.email}. Thank you for shopping with{" "}
            {storeProfile?.storeName}.
          </p>
        </div>


        <EarnableRewards isTitle={false} isOrderComplete={true} />
      </div>

      <section className="!pb-10 lg:!pb-20">
        <div className="!px-5 md:!px-10 lg:!px-16">
          <div className="flex flex-wrap relative bg-py_black-50 rounded-[1rem] p-10 overflow-hidden h-[460px] md:p-16 lg:px-22 lg:w-full sm:h-[500px] lg:h-[440px]  lg:py-26">
            <div className="w-full text-py_black-950 lg:w-1/2">
              <div className="flex flex-col gap-5 md:gap-10">
                <h5 className="text-[1.5rem] font-semibold leading-[120%] tracking-[-0.64px] lg:text-[2rem] lg:mr-10">
                  Download Paycurra Wallet to claim and use your rewards on your
                  next order
                </h5>
                <div className="flex gap-4">
                  <IconButton className="!inline-block !w-fit !rounded-none	!p-0">
                    <Link to={urlConfig.APP_STORE.google}>
                      <img
                        src={images.PlayStoreImg}
                        alt="Download paycurra on google play store"
                        width={140}
                        height={32}
                        className="object-cover"
                      />
                    </Link>
                  </IconButton>
                  <IconButton className="!inline-block !w-fit !rounded-none	!p-0">
                    <Link to={urlConfig.APP_STORE.apple}>
                      <img
                        src={images.AppleStoreImg}
                        alt="Download paycurra on app store"
                        width={140}
                        height={40}
                        className="object-cover"
                      />
                    </Link>
                  </IconButton>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2">
              {/* Desktop */}
              <img
                src={images.DMobileTopMockUp}
                alt=""
                width={300}
                height={500}
                className="absolute hidden lg:block lg:top-0 lg:rotate-0"
              />
              <img
                src={images.DMobileBotttomMockUp}
                alt=""
                width={300}
                height={500}
                className="absolute bottom-0 hidden lg:block lg:right-[5.75rem]"
              />
              <img
                src={images.MMobile2MockUp}
                alt=""
                width={350}
                height={470}
                className="absolute bottom-0 sm:!-bottom-20 z-10 w-[200px] right-10 sm:w-[350px] lg:hidden"
              />
              <img
                src={images.MMobile1MockUp}
                alt=""
                width={350}
                height={480}
                className="absolute w-[200px] -bottom-10 sm:-bottom-48 left-5 md:right-6 md:top-[325] sm:w-[350px] lg:hidden"
              />
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};
